export default "__VITE_ASSET__D4YzH_EN__"